module.exports = __webpack_public_path__ + "static/media/btbbank.7e1fd08d.svg";